import axios from "axios";

const studentApi = axios.create({
    baseURL: `/course-evaluations/student`,
  });

export const getStudentByHashedStudentId = async (hashedStudentId, brandId) => {
    const params = { brandId: brandId };
    const { data } = await studentApi.get(`/${encodeURIComponent(hashedStudentId)}`, { params });
    return data;
}

export const doesStudentExist = async (hashedStudentId, brandId) => {
  const params = { brandId: brandId };
  const { data } = await studentApi.get(`/${encodeURIComponent(hashedStudentId)}/exist`, { params });
  return data;
}